export const LANGUAGE_DETAIL = 'LANGUAGE_DETAIL';
